import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'formattedCurrency',
  standalone: true
})
export class FormattedCurrencyPipe implements PipeTransform {
  private readonly currencyPipe = new CurrencyPipe('en-US');

  constructor() {}

  transform(
    value?: number | string | null,
    currencyCode: string = 'USD',
    display: 'symbol' | 'code' | 'name' = 'symbol',
    digitsInfo: string = '1.2-2'
  ): string | null {
    if (value == null) {
      return '-';
    }

    let result = value;
    try {
      result = this.currencyPipe.transform(
        value,
        currencyCode,
        display,
        digitsInfo
      )!;
    } catch (e) {
      result = value;
    }
    return (result || '')?.toString();
  }
}
